/**
 * It takes an array of strings, arrays, and objects, and returns a string of all the truthy values
 * @param args - array of strings, arrays, and objects
 * @returns a string of class names.
 */
export function cx(...args: C[]) {
  const classes = args.reduce<Array<string | string[]>>((acc, cur) => {
    if (cur == null || [false, ""].includes(cur as string)) return acc

    if (typeof cur === "string") {
      return [...acc, cur]
    }

    if (Array.isArray(cur)) {
      return [...acc, ((cur[0] as boolean) ? cur[1] : cur[2]) ?? []]
    }

    return [...acc, Object.keys(Object.fromEntries(Object.entries(cur ?? {}).filter((i) => Boolean(i[1]))))]
  }, [])

  return [...new Set(classes.flat())].join(" ").replace(/\s{2,}/g, " ")
}

type C = undefined | null | false | string | [unknown, string, string?] | { [key: string]: unknown }
